import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  makeStyles,
} from '@material-ui/core';
import { useSelector } from 'react-redux';

import Divider from '../Divider';
import Button from '../Button';

import './style.scss';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 500,
    boxShadow: '0px 13px 18px rgba(0, 0, 0, 0.15)',
    borderRadius: 2,
    [theme.breakpoints.up('xs')]: {
      width: '100%',
    },
    [theme.breakpoints.up('sm')]: {
      width: 859,
    },
  },
  header: {
    height: 74,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f1f1f1',
    borderRadius: '0 0 20% 20%',
  },
  headerTitle: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#004987',
    textAlign: 'center',
  },
  cardContent: {
    [theme.breakpoints.up('sm')]: {
      paddingLeft: '36px',
      paddingRight: '36px',
    },
  },
}));

const getTotalAmount = (coverages) => {
  let totalAmount = 0;
  coverages.forEach((coverage) => {
    let amount = coverage.amount.replace(/,/g, '');
    amount = amount.split('.')[0];
    totalAmount += parseInt(amount);
  });
  return totalAmount.toLocaleString();
};

export default function PlanCardDetail({ plan, nextStep, handleModal }) {
  const classes = useStyles();
  const history = useHistory();

  const { insuranceCoverages, longDesc, price, prize } = plan || {};
  const totalAmount = getTotalAmount(insuranceCoverages);

  const { insuranceName } = useSelector(({ insurances }) => ({
    insuranceName: insurances.selected.insuranceName,
  }));

  const { userCarInsurance } = useSelector(({ carInsurance }) => ({
    userCarInsurance: carInsurance.userCarInsurance,
    carTotalAmountInsured: carInsurance.userCarInsurance.carTotalAmountInsured,
  }));

  const handleClick = () => {
    if (
      insuranceName === 'TECNO' ||
      insuranceName === 'VIDA INDIVIDUAL' ||
      insuranceName === 'INTEGRAL DE COMERCIO'
    ) {
      return handleModal(true);
    } else {
      history.push(nextStep);
    }
  };

  return (
    <Card className={classes.root}>
      <CardHeader
        title={`PLAN ${longDesc && longDesc.replace(/plan/gi, '')}`}
        classes={{
          root: classes.header,
          title: classes.headerTitle,
        }}
      />
      <CardContent
        classes={{
          root: classes.cardContent,
        }}
      >
        <Box
          component='span'
          display='block'
          textAlign='center'
          color='#323232'
        >
          Coberturas
        </Box>
        <Divider my='16px' />

        {insuranceCoverages.map((coverage) => (
          <Box
            key={coverage.insuranceCoverageId}
            display='flex'
            justifyContent='space-between'
            alignItems='baseline'
            mb='20px'
            fontSize={13}
          >
            <Box display='flex'>
              <Box width='15px' mr='5px'>
                <img
                  src={require('../../img/check.svg')}
                  alt=''
                  style={{ width: '100%', height: 'auto' }}
                />
              </Box>
              <Box component='span' color='#616161' fontWeight={300}>
                {coverage.description}
              </Box>
            </Box>
            {insuranceName !== 'AUTOMOTOR' ? (
              <Box ml='10px' color='#323232'>
                ${coverage.amount}
              </Box>
            ) : (
              ''
            )}
          </Box>
        ))}
        <Divider my='10px' />
        <Box
          display='flex'
          justifyContent='space-between'
          alignItems='baseline'
          className='cardRow totalRow'
          mb='20px'
        >
          <Box component='span' color='#616161' fontWeight={300}>
            <b>SUMA ASEGURADA</b>
          </Box>
          {insuranceName !== 'AUTOMOTOR' ? (
            <Box ml='10px' color='#323232'>
              <b>TOTAL ${totalAmount}</b>
            </Box>
          ) : (
            <Box ml='10px' color='#323232'>
              <b>
                TOTAL $
                {parseFloat(userCarInsurance.carTotalAmountInsured).toFixed(0)}
              </b>
            </Box>
          )}
        </Box>
        <Box textAlign='center'>
          <h5 className='monthly-price'>
            $
            <Box component='span' fontSize={38}>
              {insuranceName === 'AUTOMOTOR'
                ? parseFloat(prize).toFixed(0)
                : parseFloat(price).toFixed(0)}
            </Box>
            /mes
          </h5>
          <Button
            onClick={() => handleClick()}
            theme='rounded'
            width={124}
            height={38}
          >
            CONTRATAR
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}
